const logo = require("./logo-text.png");

export default logo;
